import { useFeedback, useTranslation } from "@opendash/core";
import { Button, Form, Modal } from "antd";
import React, { useState } from "react";
import { saveTicket, TicketData } from "../..";
import { Kanban_State } from "../../../../js/parsegenerated";
import { SaveTicketValuesWithFullMeta } from "../../creation/types/SaveTicketValues";
import { StateFormItem } from "./StateFormItem";

type TicketMessageModalProps = {
  ticketData: TicketData[];
  newState: Kanban_State;
  open: boolean;
  onSaveSuccess?: Function;
  onSaveError?: Function;
  onSaveCancel?: Function;
};

export const TicketStateModal = (props: TicketMessageModalProps) => {
  const t = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { handleLoadingFeedback } = useFeedback();

  const formItems = props.ticketData?.map((data) => {
    return (
      <StateFormItem
        ticketData={data}
        nextState={props.newState}
        priority={data.priority}
        key={data.ticket.id}
      />
    );
  });

  function onCancel() {
    if (props.onSaveCancel) props.onSaveCancel();
  }

  async function onSubmit() {
    const values = await form.validateFields();
    setLoading(true);

    try {
      const promises: Promise<any>[] = [];
      for (const key in values) {
        const segments = key.split("_");
        const type = segments[0];
        const ticketId = segments[1];
        const currentData = props.ticketData.find(
          (data) => data.ticket.id === ticketId
        );

        const saveValues: SaveTicketValuesWithFullMeta = {
          existingTicketId: ticketId,
          state: props.newState.id,
        };

        if (type === "description" && values[key] !== undefined) {
          saveValues.message = {
            title: "maintenance:ticket.move.state.message.title",
            description: values[key],
            data: {
              translation: {
                lastStateName: currentData.state.label,
                stateName: props.newState.label,
              },
              type: "userinput",
            },
          };
        } else if (type === "priority") {
          const value = Number(values[key]);

          const currentPriority = currentData.priority;

          if (values[key] === undefined || currentPriority?.value === value)
            continue;

          saveValues.priority = value;
        }

        promises.push(saveTicket(saveValues));
      }

      await handleLoadingFeedback(
        () => Promise.all(promises),
        t("maintenance:ticket.state.loading"),
        t("maintenance:ticket.state.success"),
        t("maintenance:ticket.state.error")
      );

      props.onSaveSuccess?.();
    } catch (e) {
      props.onSaveError?.(e);
      console.error(e);
    }
    setLoading(false);
  }

  return (
    <Modal
      title={t("maintenance:ticket.move.headline")}
      open={props.open}
      onOk={onSubmit}
      onCancel={onCancel}
      width={"80%"}
      getContainer={false}
      zIndex={1001}
      footer={[
        <Button key="back" onClick={onCancel}>
          {t("maintenance:global.button.cancel_label")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={onSubmit}
        >
          {t("maintenance:global.button.save_label")}
        </Button>,
      ]}
    >
      <Form autoComplete="off" form={form} layout="vertical">
        {formItems}
      </Form>
    </Modal>
  );
};
